import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import revenueData from '../../Data/revenuebyarea.json'; 

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RevenueByArea = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(revenueData); 
  }, []);

  return (
    <div style={{ width: '100%' }}>
      {data ? <Bar data={data} /> : <p>Loading...</p>}
    </div>
  );
};

export default RevenueByArea;
